module.exports = __webpack_public_path__ + "media/images/flags/32/Latvia-0b0e05e59918324b9687546ad0ca19e8.png";